/**
 * Created by tayloremolo on 11/5/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import IframeVideo from "../components/iframe-video";

class CTA extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <a href="http://www.fownders.co/mastermind-step-1" className="btn-large cta-org waves-effect waves-light">BUY TICKET</a>
            </div>
        )

    }

}

export default CTA;



// WEBPACK FOOTER //
// ./src/components/cta.js